import { InputNames } from '../models/InputsModel';

interface ICommonProps {
	name: InputNames;
}

interface IDefineInputValue extends ICommonProps {
	inputValue: { valorInicial: string; valorFinal: string };
}

interface IDefineBorderColorValue extends ICommonProps {
	validation?: boolean;
}

export const defineInputValue = ({
	name,
	inputValue,
}: IDefineInputValue): string => {
	return name === 'valorInicial'
		? inputValue.valorInicial
		: inputValue.valorFinal;
};

export const defineBorderColorValue = ({
	name,
	validation,
}: IDefineBorderColorValue): string => {
	return name === 'valorFinal' && validation ? 'red' : 'inherit';
};
